import registracionLib from '@ln/registracionlibs';
import SwGHelper from '../../common/helpers/SubscribeWithGoogleHelper';
import { model } from '../core/model'
import { Config } from "../core/config"
import analytics from "../helpers/analytics"


const libs = () => {
    if (!model.Window.lightMode) {
        startRegistrationLibs('googlebutton');
        startRegistrationLibs('googlepayContainer');
        startGoogleTagManager();
        startHotjar();
        startGoogleOptimize();
        //startGoogleAnalytics();
        //initializeGoogleAnalytics();
        setTimeout(() => {
            startComscore();
            startEstadisticas();
            initWChat();
        }, 0);
    }
}


const startGoogleAnalytics = function () {
    (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments)
        }, i[r].l = 1 * new Date(); a = s.createElement(o),
            m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
    })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
    ga && ga('create', Config.gaId, 'auto');
}

const initializeGoogleAnalytics = function () {
    if (typeof ga === 'function' && ga.loaded) {
        return;
    }

    (function init() {
        if (typeof ga === 'function') {
            ga('create', Config.gaId, 'auto');
        }
        else {
            setTimeout(init, 100);
        }
    })();
}

const startGoogleTagManager = function () {
    (function (w, d, s, l, i) {
        w[l] = w[l] || []; w[l].push({
            'gtm.start':
                new Date().getTime(), event: 'gtm.js'
        }); var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s), dl = l != 'dataLayer' ? '&amp;l=' + l : ''; j.async = true; j.src =
                '//www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', Config.gtmId);
}

const startHotjar = function () {
    (function (h, o, t, j, a, r) {
        h.hj = h.hj || function () { (h.hj.q = h.hj.q || []).push(arguments) };
        h._hjSettings = { hjid: parseInt(Config.hotjarId), hjsv: 6 };
        a = o.getElementsByTagName('head')[0];
        r = o.createElement('script'); r.async = 1;
        r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
}

const startComscore = function () {
    var _comscore = _comscore || [];
    _comscore.push({ c1: "2", c2: "6906398" });
    (function () {
        var s = document.createElement("script"), el = document.getElementsByTagName("script")[0]; s.async = true;
        s.src = (document.location.protocol == "https:" ? "https://sb" : "http://b") + ".scorecardresearch.com/beacon.js";
        el.parentNode.insertBefore(s, el);
    })();
}

const startSwG = function (callback) {
    (window.SWG = window.SWG || []).push(function (subscriptions) {
        (Model.SWGSubscriptions = Model.SWGSubscriptions || subscriptions).init('lanacion.com.ar:acceso_digital');
        callback(Model.SWGSubscriptions);
    });

}


const startGoogleOptimize = function () {
    //Agregar a styles 
    //2.	<style>.async-hide { opacity: 0 !important} </style>
    (function (a, s, y, n, c, h, i, d, e) {
        s.className += ' ' + y; h.start = 1 * new Date;
        h.end = i = function () { s.className = s.className.replace(RegExp(' ?' + y), '') };
        (a[n] = a[n] || []).hide = h; setTimeout(function () { i(); h.end = null }, c); h.timeout = c;
    })(window, document.documentElement, 'async-hide', 'dataLayer', 4000, { 'GTM-GHV6': true });
}

const startEstadisticas = function () {
    var rand_no = Math.random();
    var ip = '190.220.56.0'; /* NO SOY FELIZ HACIENDO ESTO -- ALE */
    rand_no = Math.ceil(rand_no * 1000000000);
    var s = document.createElement("img");
    s.src = 'https://estadisticas.lanacion.com.ar/diario/default.gif?pagina=muropaywall&servidor=' + ip + '&nro=' + rand_no + '&usuario=' + model.Usuario.UsuarioId;
    s.width = "1";
    s.height = "1";
    document.body.appendChild(s);
}


const initWChat = function () {
    if (Config.idWcentrix) {
        setTimeout(function () {
            var s;
            if (window.innerWidth >= 767) {
                s = document.createElement("script");
                s.defer = true;
                s.src = "https://wcentrix.net/tabhelp/wctabs.aspx?id=" + Config.idWcentrix + "&" + (new Date).getTime();
                document.head.appendChild(s);
            }
        }, Config.wCentrixTime);
    }
}

const startRegistrationLibs = function (div) {
    if (!div)
        return;
    
    if (document.getElementsByClassName(div)[0]) {
        registracionLib.init();
        let googleBtnData = document.getElementsByClassName(div)[0].dataset;
        let { name, price, sku } = googleBtnData;
        let payload = analytics.getGoogleTransactionPayload(name, price, sku);
        window.GoogleSubscribe.start(function () {
            SwGHelper.BtnGoogle(div);
        },
        payload,
        analytics.trackCustomDimension);
    }

}




export default libs;


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/libs/index.js